// const parseCardsToAccordionPanels = (data) => {
//   const cardRegex = /<card (.*?)>(.*?)<\/card>/gs;
//   const attributesRegex = /(title|header)="(.*?)"/g;

//   let match;
//   const panels = [];
//   let key = 1;

//   while ((match = cardRegex.exec(data)) !== null) {
//     const attributes = {};
//     let attrMatch;
//     while ((attrMatch = attributesRegex.exec(match[1])) !== null) {
//       attributes[attrMatch[1]] = attrMatch[2];
//     }
//     const content = match[2].trim();
//     panels.push({
//       key: key++,
//       title: attributes.title || attributes.header,
//       content,
//     });
//   }

//   return panels;
// };

// export default parseCardsToAccordionPanels

const parseCardsToAccordionPanels = (data) => {
  const cardRegex = /<card (.*?)>(.*?)<\/card>/gs; // Regex para capturar cada <card>
  const attributesRegex = /(title|header|class)="(.*?)"/g; // Regex para capturar atributos específicos

  let match;
  const panels = [];
  let key = 1;

  while ((match = cardRegex.exec(data)) !== null) {
    const attributes = {};
    let attrMatch;

    // Extraer atributos (title, header, class)
    while ((attrMatch = attributesRegex.exec(match[1])) !== null) {
      attributes[attrMatch[1]] = attrMatch[2];
    }

    const content = match[2].trim(); // Extraer el contenido dentro de <card>
    panels.push({
      key: key++,
      title: attributes.title || attributes.header, // Usar "title" o "header"
      content,
      className: attributes.class || '', // Extraer "class" o usar cadena vacía si no existe
    });
  }

  return panels;
};

export default parseCardsToAccordionPanels;